import React from "react"
import BuyPage from "../components/BuyPage"

const BuyXtk = () => {
  return (
    <>
      <BuyPage />
    </>
  )
}

export default BuyXtk
